// ** React Imports
import { useEffect, useState } from 'react'

const BlankLayout = ({ children }) => {
  // ** States
  const [isMounted, setIsMounted] = useState(false)

  //** ComponentDidMount
  useEffect(() => {
    setIsMounted(true)
    return () => setIsMounted(false)
  }, [])

  if (!isMounted) {
    return null
  }

  return <div className="blank-page">{children}</div>
}

export default BlankLayout
